
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "__swiper": {
    "bundled": true
  },
  "_MAPBOX_CONFIG": {
    "accessToken": "pk.eyJ1IjoiYW1pcmRhcnlhZWUiLCJhIjoiY2xlcXVpenA4MHB0dzQ3bzFreTVpcjZkdCJ9.PFgDJG1nNGoJx5ISZctnKA"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
